export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'LU',
  'merchantReturnLink': 'https://www.timberland.lu/nl-lu/klantenservice/retour-instructies',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
